export default {
  title: "日報プリセット一覧",
  documentTitle: "日報プリセット",
  name: "名称",
  errors: {
    getList: "一覧の取得に失敗しました。"
  },
  list: {
    id: "ID",
    note: "備考",
    updateAt: "最終更新日",
    updateBy: "最終更新者",
    edit: "編集",
    update: "更新",
    delete: "削除",
  },
  modal: {
    label: {
      pageUnit: "ページ単位",
      allSelect: "チャート表示をすべて選択",
      chartDisplay: "チャート表示",
      memo: "メモ",
      reportLayout: {
        title: "日報レイアウト",
        workDetails: "作業詳細",
        etcDetails: "ETC詳細"
      }
    },
    isNote: {
      yes: "有",
      none: "無し"
    },
    validate: {
      input: "入力してください"
    }
  }
}
